// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.spinner > div {
  background-color: #536584;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  margin: 10px 6px;
  animation: 1.4s ease-in-out infinite both sk-bouncedelay;
  display: inline-block;
}

.spinner .bounce1 {
  animation-delay: -.32s;
}

.spinner .bounce2 {
  animation-delay: -.16s;
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/LoaderAndText/spinner.css","webpack://./services/frontend/app/containers/LoaderAndText/spinner.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".spinner {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.spinner > div {\n  width: 20px;\n  height: 20px;\n  margin: 10px 6px;\n  background-color: #536584;\n  border-radius: 100%;\n  display: inline-block;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  animation-delay: -0.16s;\n}\n\n@keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1);\n  }\n}\n",".spinner {\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.spinner > div {\n  background-color: #536584;\n  border-radius: 100%;\n  width: 20px;\n  height: 20px;\n  margin: 10px 6px;\n  animation: 1.4s ease-in-out infinite both sk-bouncedelay;\n  display: inline-block;\n}\n\n.spinner .bounce1 {\n  animation-delay: -.32s;\n}\n\n.spinner .bounce2 {\n  animation-delay: -.16s;\n}\n\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
